"use client";
import React, { useEffect, useState } from "react";
import axios from "axios";
import Offcanvas from "react-bootstrap/Offcanvas";
// import "../../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import Accordion from "react-bootstrap/Accordion";
import Link from "next/link";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";
import Image from "next/image";
import OffcanvasClose from "../../../../public/assets/images/offcanvas-close.svg";

const NEW_MENU_SLUGS = ["services", "industries"];

const Header = () => {
	const router = useRouter();
	const slug = router?.query?.slug;
	const [subMenuClass, setSubMenuClass] = useState("");
	const [childLinkData, setChildLinkData] = useState();
	const [activeService, setActiveService] = useState(null);
	const [resourceData, setResourceData] = useState();
	const [title, setTitle] = useState();
	const [menuTitle, setMenuTitle] = useState();
	const [isNewMenu, setIsNewMenu] = useState();
	const [submenuData, setSubmenuData] = useState({
		description: "",
		image: "",
	});
	const [activeServiceIndex, setActiveServiceIndex] = useState(null);


	const headerFooterData = useSelector(
		(state) => state.headerFooterData.headerFooterDataList
	);

	const MOBILE_SERVICES_MENU = [
		{
			title: "Cyber Security",
			slug: "cyber-security",
			children: [
				{ title: "VAPT", slug: "vapt" },
				{ title: "SOC Monitoring", slug: "soc-monitoring" },
				{ title: "SIEM", slug: "siem" }
			]
		},
		{
			title: "RPA Solutions",
			slug: "rpa-solutions",
			children: [
				{ title: "UiPath", slug: "uipath" },
				{ title: "Automation Anywhere", slug: "automation-anywhere" }
			]
		},
		{
			title: "IoT Solutions",
			slug: "iot-solutions",
			children: [
				{ title: "Smart Factory", slug: "smart-factory" },
				{ title: "Fleet Tracking", slug: "fleet-tracking" }
			]
		}
	];

	const [headerData, setHeaderData] = useState();

	useEffect(() => {
		const fetchHeaderData = async () => {
			try {
				const response = await axios.get(
					process.env.NEXT_PUBLIC_API_ENDPOINT +
					"/cms/pages/?child_of=36&show_in_menus=true"
				);
				const data = response?.data && response?.data?.results;
				data && setHeaderData(data);
			} catch (error) {
				console.log("error", error);
			}
		};
		fetchHeaderData();
	}, []);

	const [sticky, setSticky] = useState("");

	// on render, set listener

	// header Sticky
	useEffect(() => {
		window.addEventListener("scroll", isSticky);
		return () => {
			window.removeEventListener("scroll", isSticky);
		};
	}, []);
	// 	useEffect(() => {
	//   if (!show) {
	//     setActiveServiceIndex(null);
	//   }
	// }, [show]);

	const handleServicesHover = () => {
		if (childLinkData?.length > 0) {
			setActiveService(childLinkData[0]);
			setSubmenuData({
				description: childLinkData[0]?.description,
				image: childLinkData[0]?.image?.url,
			});
		}
	};
	useEffect(() => {
		if (
			menuTitle === "Services" &&
			childLinkData?.length &&
			!activeService
		) {
			setActiveService(childLinkData[0]);
			setSubmenuData({
				description: childLinkData[0]?.description,
				image: childLinkData[0]?.image?.url,
			});
		}
	}, [menuTitle, childLinkData]);



	const isSticky = () => {
		/* Method that will fix header after a specific scrollable */
		const scrollTop = window.scrollY;
		const stickyClass =
			scrollTop >= 150 ? "fixed-top slideInDown animated" : "";
		setSticky(stickyClass);
	};

	const headersticky = `header ${sticky}`;
	// End header Sticky

	const [show, setShow] = useState(false);

	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);

	// closes submenu
	useEffect(() => {
		setSubMenuClass("d-none");
		setTimeout(() => {
			setSubMenuClass("");
		}, 50);
	}, [slug]);

	const [pageURL, setPageURL] = useState(0);
	useEffect(() => {
		setPageURL(window.location.pathname);
	});

	useEffect(() => {
		console.clear();
	}, []);

	return (
		<header
			className={`${headersticky} ${pageURL === "/careers" ? "transparent-sticky-header" : ""
				}`}
		>
			<nav className="navbar navbar-expand-lg">
				<div className="container">
					<div className="main-navbar">
						<div className="logo">
							<Link
								className="navbar-brand"
								href="/"
								itemProp="logo"
							>
								<Image
									width={500}
									height={500}
									// src="/quixom-logo.svg"
									src="/img/Quixom Logo.svg"
									alt="Quixom logo"
									loading="eager"
									priority
								/>
							</Link>
						</div>
						<div className="navbar-right">
							<button
								className="navbar-toggler"
								type="button"
								onClick={handleShow}
								aria-label="menu"
							>
								<span className="navbar-toggler-icon"></span>
							</button>

							{["end"].map((placement, idx) => (
								<Offcanvas
									key={idx}
									show={show}
									onHide={handleClose}
									placement={placement}
									name={placement}
									responsive="lg"
									className="mobile-Offcanvas"
								>
									<div className="offcanvas-header">
										<div
											className="offcanvas-title"
											id="offcanvasNavbarLabel"
										>
											<Link
												className="navbar-brand"
												href="#"
												itemProp="logo"
											>
												<Image
													width={500}
													height={500}
													src={
														headerFooterData &&
														headerFooterData.site_configuration &&
														headerFooterData
															?.site_configuration[0]
															?.logo?.url
													}
													alt={
														(headerFooterData &&
															headerFooterData.site_configuration &&
															headerFooterData
																?.site_configuration[0]
																?.logo?.alt_text) ||
														"Quixom logo"
													}
													priority
													loading="eager"
												/>
											</Link>
										</div>
										<button
											type="button"
											className="btn-close"
											onClick={handleClose}
										>
											<Image
												src={OffcanvasClose}
												alt="offcanvas-close"
												height={100}
												width={100}
												loading="eager"
											/>
										</button>
									</div>
									<div className="offcanvas-body">
										<ul className="navbar-nav web-navbar justify-content-end flex-grow-1">
											{headerData?.map((val, index) => (
												<React.Fragment key={index}>
													<li
														className="nav-item"
														onMouseEnter={() => {
															setIsNewMenu(
																NEW_MENU_SLUGS.includes(
																	val?.meta
																		?.slug
																)
															);
															setMenuTitle(
																val?.title
															);
															setChildLinkData(
																val?.child
															);
															setTitle(
																val?.meta?.slug
															);
															setResourceData(
																val?.detail
															);
															if (
																subMenuClass.length
															) {
																setSubMenuClass(
																	""
																);
															}
														}}
													>
														{title ==
															"industries" ||
															title == "resource" ||
															title == "services" ||
															title == "Contact Us" ||
															title ==
															"product-development" ? (
															<span
																className="nav-link"
																role="button"
															>
																{val?.title}
															</span>
														) : (
															<Link
																className="nav-link"
																aria-current="page"
																href={val?.url}
																itemProp="menu"
															>
																{val?.title}
															</Link>
														)}

														{childLinkData &&
															childLinkData.length >
															0 && (
																<React.Fragment>
																	<div
																		className={`submenu ${isNewMenu &&
																			"submenu-services"
																			} ${subMenuClass}`}
																	>
																		<div className="submenu-inner">
																			<div className="container">
																				<div className="row">
																					<div
																						className={
																							isNewMenu
																								? "col-lg-12"
																								: "col-lg-6"
																						}
																					>
																						<div className="submenu-left-inner">
																							<div className="submenu-heading">
																								<p
																									itemProp="heading"
																									className="sub-menu-title"
																									onMouseEnter={() => {
																										if (menuTitle === "Services") {
																											handleServicesHover();
																										}
																									}}

																								>
																									{
																										menuTitle
																									}
																								</p>
																								{menuTitle === "Services" &&
																									childLinkData?.map((val, index) => (
																										<p
																											key={index}
																											className={`sub-menu-list-title
																												 ${activeService?.title === val?.title ? "active" : ""
																												}`}
																											onMouseEnter={() => {
																												setActiveService(val);
																												setSubmenuData({
																													description: val?.description,
																													image: val?.image?.url,
																												});
																											}}
																										>
																											<Link
																												className="sub-menu-link"
																												href={val?.url}
																											>
																												{val?.title}
																											</Link>
																											<Image
																												src="/assets/images/blog-right-arrow.svg"
																												alt="right-arrow"
																												height={20}
																												width={20}
																											/>
																										</p>
																									))}




																							</div>
																							<div className="sub-menu-content">
																								<ul>
																									{/* SERVICES: show active service children */}
																									{title === "services" && activeService
																										? activeService?.child?.map((child, idx) => (
																											<li
																												key={idx}
																											>
																												{/* {child?.title} */}
																												<Link
																													className="sub-menu-link"
																													href={child?.url}
																												>
																													{child?.title}
																												</Link>
																											</li>
																										))
																										: /* OTHER MENUS: existing behavior */
																										title != "services" && childLinkData?.map((val, index) => (
																											<li
																												key={index}
																											>
																												<Link
																													className="sub-menu-link"
																													href={
																														(title === "industries" &&
																															`/industries/${val?.meta?.slug}`) ||
																														(title === "product-development" &&
																															`/services/${val?.meta?.slug}`)
																													}
																												>
																													{val?.title}
																												</Link>
																											</li>
																										))}
																								</ul>
																							</div>

																						</div>
																					</div>
																					{!isNewMenu && (
																						<div className="col-lg-6">
																							<div className="submenu-right-inner">
																								<div className="submenu-card">
																									<div className="submenu-card-thumbnail">
																										<Image
																											src={
																												submenuData?.image ||
																												childLinkData[0]
																													?.image
																													?.url
																											}
																											alt={
																												childLinkData[0]
																													?.image
																													?.alt_text ??
																												"Services"
																											}
																											height={
																												500
																											}
																											width={
																												500
																											}
																											loading="eager"
																											style={{
																												height: "auto",
																												width: "auto",
																											}}
																										/>
																									</div>
																									<div className="submenu-card-content">
																										<p
																											dangerouslySetInnerHTML={{
																												__html:
																													submenuData?.description ||
																													childLinkData[0]
																														?.description,
																											}}
																										></p>
																									</div>
																								</div>
																								<div className="submenu-btn-grup">
																									{headerFooterData &&
																										headerFooterData?.navbar_submenu &&
																										headerFooterData?.navbar_submenu[0]?.menus?.map(
																											(
																												val
																											) => (
																												<div
																													key={
																														val?.id
																													}
																													className="submenu-btn"
																												>
																													<Link
																														className="btn btn-secondary"
																														href={
																															val
																																?.value
																																?.page
																																?.url
																														}
																														dangerouslySetInnerHTML={{
																															__html: val
																																?.value
																																?.title,
																														}}
																													></Link>
																												</div>
																											)
																										)}
																								</div>
																							</div>
																						</div>
																					)}
																				</div>
																			</div>
																		</div>
																	</div>
																</React.Fragment>
															)}

														{title ===
															"resource" && (
																<div className="submenu">
																	<div className="submenu-inner">
																		<div className="container">
																			<div className="row">
																				<div className="col-lg-4">
																					<div className="submenu-left-inner">
																						<div className="submenu-heading">
																							<p
																								itemProp="heading"
																								className="sub-menu-title"
																							>
																								{
																									val?.title
																								}
																							</p>
																						</div>
																					</div>
																				</div>
																				<div className="col-lg-8 submenu-right-col">
																					<div className="submenu-right-inner">
																						<div className="submenu-blog-div">
																							<div className="row">
																								{resourceData?.map(
																									(
																										val,
																										index
																									) => {
																										return (
																											<div
																												key={
																													index
																												}
																												className="col-md-6"
																											>
																												<Link
																													href={
																														val
																															?.value[0]
																															?.value
																															?.page
																															?.url
																													}
																													className="submenu-blog-link"
																												>
																													<div className="submenu-blog-card">
																														<div className="submenu-blog-thumbnail">
																															<Image
																																src={
																																	val
																																		?.value[0]
																																		?.value
																																		?.image
																																		?.url
																																}
																																alt={
																																	val
																																		?.value[0]
																																		?.value
																																		?.image
																																		?.alt_text ??
																																	"Services"
																																}
																																height={
																																	500
																																}
																																width={
																																	500
																																}
																																loading="eager"
																															/>
																														</div>
																														<div className="submenu-blog-content">
																															<span>
																																{
																																	val
																																		?.value[0]
																																		?.value
																																		?.title
																																}
																															</span>
																															<p
																																dangerouslySetInnerHTML={{
																																	__html: val
																																		?.value[0]
																																		?.value
																																		?.description,
																																}}
																															></p>
																														</div>
																													</div>
																												</Link>
																											</div>
																										);
																									}
																								)}
																							</div>
																						</div>
																						<div className="submenu-btn-grup">
																							{headerFooterData &&
																								headerFooterData?.navbar_submenu &&
																								headerFooterData?.navbar_submenu[0]?.menus?.map(
																									(
																										val
																									) => (
																										<div
																											key={
																												val?.id
																											}
																											className="submenu-btn"
																										>
																											<Link
																												className="btn btn-secondary"
																												href={
																													val
																														?.value
																														?.page
																														?.url
																												}
																												dangerouslySetInnerHTML={{
																													__html: val
																														?.value
																														?.title,
																												}}
																											></Link>
																										</div>
																									)
																								)}
																						</div>
																					</div>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															)}
													</li>
												</React.Fragment>
											))}
										</ul>

										<div className="mobile-menu">
											<div className="mobile-menu-inner">
												<Accordion>
													{headerData?.map(
														(val, index) => {
															return (
																<Accordion.Item
																	key={index}
																	eventKey={
																		index
																	}
																>
																	{(val?.title ==
																		"About Us" ||
																		val?.title ==
																		"Careers" ||
																		val?.title ==
																		"Contact Us") && (
																			<Accordion.Button
																				onClick={() => {
																					setChildLinkData(
																						val?.child
																					);
																					setTitle(
																						val
																							?.meta
																							?.slug
																					);
																					if (
																						val?.title ===
																						"Resource"
																					) {
																						setResourceData(
																							val?.detail
																						);
																					}
																				}}
																				onMouseEnter={() => {
																					setChildLinkData(
																						val?.child
																					);
																					setTitle(
																						val
																							?.meta
																							?.slug
																					);
																					if (
																						val?.title ===
																						"Resource"
																					) {
																						setResourceData(
																							val?.detail
																						);
																					}
																				}}
																				className="no-child"
																			>
																				{["industries", "services", "resource", "product-development"].includes(val?.meta?.slug) ? (
																					<span style={{ color: "var(--primary-color)" }}>{val?.title}</span>
																				) : (
																					<Link
																						href={val?.url}
																						onClick={handleClose}
																					>
																						{val?.title}
																					</Link>
																				)}
																			</Accordion.Button>
																		)}
																	{val?.title !=
																		"About Us" &&
																		val?.title !=
																		"Careers" &&
																		val?.title !=
																		"Contact Us" && (
																			<Accordion.Button
																				onClick={() => {
																					setChildLinkData(
																						val?.child
																					);
																					setTitle(
																						val
																							?.meta
																							?.slug
																					);
																					if (
																						val?.title ===
																						"Resource"
																					) {
																						setResourceData(
																							val?.detail
																						);
																					}
																				}}
																				onMouseEnter={() => {
																					setChildLinkData(
																						val?.child
																					);
																					setTitle(
																						val
																							?.meta
																							?.slug
																					);
																					if (
																						val?.title ===
																						"Resource"
																					) {
																						setResourceData(
																							val?.detail
																						);
																					}
																				}}
																			>
																				{["industries", "services", "resource", "product-development"].includes(val?.meta?.slug) ? (
																					<span style={{ color: "var(--primary-color)" }}>{val?.title}</span>
																				) : (
																					<Link
																						href={val?.url}
																						onClick={handleClose}
																					>
																					{val?.title}
																				</Link>
																			)}
																		</Accordion.Button>
																	)}
																<Accordion.Body>
																	{val?.meta?.slug === "services" && (
																		<div className="mobile-sub-navbar">
																			<ul className="mobile-sub-menu">

																				{val?.child?.map((service, index) => (
																					<li key={index}>

																						{/* SERVICES : MULTI LEVEL */}
																						<div className="mobile-menu-row d-flex justify-content-between">
																							{/* text → landing */}
																							<Link
																								href={service?.url}
																								className="mobile-menu-link"
																								onClick={handleClose}
																							>
																								{service.title}
																							</Link>

																							{/* arrow toggle */}
																							<span
																								className="mobile-menu-toggle"
																								onClick={(e) => {
																									e.preventDefault();
																									e.stopPropagation();
																									setActiveServiceIndex(
																										activeServiceIndex === index ? null : index
																									);
																								}}
																							>
																								<Image
																									src={
																										activeServiceIndex === index
																											? "/assets/images/acordion-right-arrow.svg"
																											: "/assets/images/accordion-down-arrow.svg"
																									}
																									alt="arrow"
																									height={24}
																									width={24}
																									className="arrow-icon"
																								/>
																							</span>
																						</div>
																							{/* sub child */}
																							{activeServiceIndex === index && service?.child?.length > 0 && (
																								<ul className="mobile-sub-child-menu  v2">
																									{service.child.map((child, i) => (
																										<li key={i}>
																											<Link
																												href={child?.url}
																												onClick={handleClose}
																											>
																												{child.title}
																											</Link>
																										</li>
																									))}
																								</ul>
																							)}
																						</li>
																					))}
																				</ul>
																			</div>
																		)}

																		{/* INDUSTRIES – SINGLE LEVEL */}
																		{val?.meta?.slug === "industries" && (
																			<div className="mobile-sub-navbar">
																				<ul className="mobile-sub-menu">
																					{val?.child?.map((industry, index) => (
																						<li key={index}>
																							<Link
																								href={`/industries/${industry?.meta?.slug}`}
																								className="mobile-menu-link"
																								onClick={handleClose}
																							>
																								{industry?.title}
																							</Link>
																						</li>
																					))}
																				</ul>
																			</div>
																		)}
																		{val?.meta?.slug === "resource" && (
																			<div className="mobile-sub-navbar">
																				<ul className="mobile-sub-menu">
																					{val?.detail?.map((res, index) => {
																						const subMenuUrl = res?.value?.[0]?.value?.page?.url || res?.value?.[0]?.value?.link;
																						return (
																							<li key={index}>
																								<Link
																									href={subMenuUrl || "#"}
																									className="mobile-menu-link"
																									onClick={handleClose}
																								>
																									{res?.value?.[0]?.value?.title}
																								</Link>
																							</li>
																						);
																					})}
																				</ul>
																			</div>
																		)}
																	</Accordion.Body>



																</Accordion.Item>
															);
														}
													)}
												</Accordion>
												{/* <div className="mobile-menu-btn">
                            {headerFooterData &&
                              headerFooterData?.navbar_submenu[0]?.menus?.map(
                                (val, index) => (
                                  <Link
                                    key={index}
                                    className="btn btn-primary"
                                    href={val?.value?.page?.url}
                                    dangerouslySetInnerHTML={{
                                      __html: val?.value?.title,
                                    }}
                                  ></Link>
                                )
                              )}
                          </div> */}
											</div>
										</div>
									</div>
								</Offcanvas>
							))}

							<div key={1000} className="navbar-btn">
								<Link
									href="/request-for-proposal-quote"
									itemProp="link"
									className="btn btn-primary btn-hover-6"
								>
									Request For Proposal
								</Link>
							</div>
						</div>
					</div>
				</div>
			</nav>
			<div className="menu-overlay"></div>
		</header>
	);
};

export default Header;
